import TestType from './Testing.type';

const initialState = {
  testList: [],
  groupList: [],
  libraryList: [],
  archiveList: [],
  allOptions: [],
  editData: {},
  addParamId: '',
  selectedIds: [],
  originalTestList: [],
};

const TestReducer = (state = initialState, action) => {
  switch (action.type) {
    case TestType.ALL_TESTS:
      return {
        ...state,
        originalTestList: action.payload?.original ? action.payload?.data : state.originalTestList,
        testList: action.payload?.data,
      };
    case TestType.UPDATE_NEW_ORDER_TESTING:
      return {
        ...state,
        testList: action.payload?.data,
      };
    case TestType.SELECTED_IDS:
      return {
        ...state,
        selectedIds: action.payload,
      };
    case TestType.ALL_GROUPS:
      return {
        ...state,
        groupList: action.payload,
      };
    case TestType.ALL_LIBRARY:
      return {
        ...state,
        librayList: action.payload,
      };
    case TestType.ALL_ARCHIVED:
      return {
        ...state,
        archiveList: action.payload,
      };
    case TestType.ON_ADD_DATA:
      return {
        ...state,
        addParamId: action.payload,
      };
    case TestType.ONE_GROUP:
      return {
        ...state,
        editData: action.payload,
      };
    case TestType.ALL_OPTIONS:
      return {
        ...state,
        allOptions: action.payload,
      };
    case TestType.EMPTY_REDUCER:
      return {
        ...state,
        testList: [],
        originalTestList: [],
        groupList: [],
        libraryList: [],
        allOptions: [],
        editData: {},
        addParamId: '',
        selectedIds: [],
      };
    case TestType.DELETE_TESTING:
      return {
        ...state,
        groupList: [],
      };
    default:
      return state;
  }
};

export default TestReducer;
